












































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import HeaderField from "@/classes/HeaderField";
import Organization from "@/classes/Organization";
import User from "@/classes/User";
import HIVEButton from "@/components/common/HIVEButton.vue";
import HIVESearchBar from "@/components/common/HIVESearchBar.vue";
import HIVEAlert from "@/components/common/alerts/HIVEAlert.vue";
import HIVETextField from "@/components/common/HIVETextField.vue";
import Pagination from "@/classes/Pagination";
import PasswordValidationRule from "@/classes/rules/PasswordValidationRule";
import UserValidationRule from "@/classes/rules/UserValidationRule";
import { Role } from "@/classes/Role";

@Component({
  components: {
    HIVEButton,
    HIVESearchBar,
    HIVEAlert,
    HIVETextField,
  },
})
export default class CreateUpdateOrganizationUsers extends Vue {
  @Prop(Boolean) public complete: boolean;
  @Prop(Number) public step: number;
  @Prop(Object) public organizationAdmin: User;
  @Prop(Boolean) public isNewOrganization: boolean;
  @Prop(Object) public organization: Organization;

  private headers: Array<HeaderField> = [
    new HeaderField("", "action"),
    new HeaderField("Name", "displayName"),
    new HeaderField("Email", "email"),
    new HeaderField("Status", "status.displayName"),
    new HeaderField("Roles", "roleNames"),
    new HeaderField("Last Login", "lastLoggedInAt"),
    new HeaderField("SSO", "isSSOUser"),
    new HeaderField("Active", "isActive"),
  ];
  //private search: string = ''
  private footerProps: object = {
    "items-per-page-options": [25, 50, 100],
  };
  private emailDialog: boolean = false;
  private passwordDialog: boolean = false;
  private changeOrgDialog: boolean = false;
  private icon: boolean = true;
  private selectedUser: User = new User();
  private passwordValid: boolean = false;
  private newPassword: string = "";
  private confirmPassword: string = "";
  private passwordRule: PasswordValidationRule = new PasswordValidationRule();
  private PASSWORD_INSTRUCTIONS: string =
    "Password must be at least 8 characters long and include 3 of the following: a lower-case letter, upper-case letter, a number and a special character (&*^$!)";
  private valid: boolean = false;
  private lazy: boolean = false;
  private userRule: UserValidationRule = new UserValidationRule();
  private newEmail: string = "";
  private emailValid: boolean = false;
  private rolesDialog: boolean = false;
  private assignedRoles: Array<Role> = [];
  private searchRole: Role = new Role();

  private rowSelected: User = new User();
  private selectedOrg: Organization = new Organization();

  private get getOrganization() {
    return this.organization;
  }

  private get isComplete() {
    return this.complete;
  }

  private get getStepNumber() {
    return this.step;
  }

  private get getOrgAdmin() {
    return this.organizationAdmin;
  }

  private get newOrganization() {
    return this.isNewOrganization;
  }

  private get getUserItems() {
    return this.$store.getters["users/getSearchedUserItems"];
  }

  private set getUserItems(val: Array<User>) {
    this.$store.commit("users/setSearchedUserItems", val);
  }

  private get getExistingUserItems() {
    return this.$store.getters["users/getExistingUserItems"];
  }

  private set getExistingUserItems(val: Array<User>) {
    this.$store.commit("users/setExistingUserItems", val);
  }

  private get getIsLoading() {
    return this.$store.getters["users/getIsLoading"];
  }

  public get alertText() {
    return this.$store.getters["users/getAlertText"];
  }
  public set alertText(val: string) {
    this.$store.commit("users/setAlertText", val);
  }

  public get alertType() {
    return this.$store.getters["users/getAlertTypes"];
  }
  public set alertType(val: string) {
    this.$store.commit("users/setAlertType", val);
  }

  public get pagination() {
    return this.$store.getters["users/getPagination"];
  }
  public set pagination(val: string) {
    this.$store.commit("users/setPagination", val);
  }

  public get userStatuses() {
    return this.$store.getters["users/getStatuses"];
  }

  public get passwordResetMessage() {
    return this.$store.state.users.passwordResetMessage;
  }
  public set passwordResetMessage(msg: string) {
    this.$store.commit("users/setPasswordResetMessage", msg);
  }

  public get passwordChangedSuccessfully() {
    return this.$store.getters["users/getPasswordChangedSuccessfully"];
  }
  public set passwordChangedSuccessfully(val: boolean) {
    this.$store.commit("users/setPasswordChangedSuccessfully", val);
  }

  public get roles() {
    return this.$store.getters["users/getRoles"];
  }

  public get rolesSaved() {
    return this.$store.getters["users/getRolesSaved"];
  }
  public set rolesSaved(val: boolean) {
    this.$store.commit("users/setRolesSaved", val);
  }

  public get emailSaved() {
    return this.$store.getters["users/getEmailSaved"];
  }
  public set emailSaved(val: boolean) {
    this.$store.commit("users/setEmailSaved", val);
  }

  public get query() {
    return this.$store.getters["users/getQuery"];
  }
  public set query(val: string) {
    this.$store.commit("users/setQuery", val);
  }

  private getRoles(item) {
    return item.map((i) => i).join(", ");
  }

  public get totalUserCount() {
    return this.$store.getters["users/getTotalUserCount"];
  }

  public get organizationstoSelect() {
    return this.$store.getters["organizations/getOrganizations"];
  }

  private paginate(e: object) {
    this.pagination = e;
    this.$store.dispatch("users/searchAsync", {
      orgId: this.getOrganization.id,
      query: this.search,
    });
  }

  private searchUsers() {
    if (this.query && this.query.length >= 2) {
      this.$store.dispatch("users/searchAsync", {
        orgId: this.getOrganization.id,
        query: this.query,
        role: this.searchRole === undefined ? null : this.searchRole.name,
      });
    } else {
      if (this.searchRole) {
        this.$store.dispatch("users/searchByRoleAsync", {
          orgId: this.getOrganization.id,
          role: this.searchRole.name,
          query: this.query === null ? "" : this.query,
        });
      }
    }
  }

  private clearUsers() {
    this.query = "";
    this.getUserItems = [];
    this.getExistingUserItems = [];
  }

  private clearRoles() {
    this.searchRole = new Role();
  }

  public updateStatus(item: User) {
    let statusValue: number;
    if (item.status.intValue == 100) {
      statusValue = 200;
    } else {
      statusValue = 100;
    }
    this.$store.dispatch("users/updateStatus", {
      id: item.id,
      status: statusValue,
      orgId: this.getOrganization.id,
    });
  }

  public signUpUser(item: User, signUp: boolean) {
    this.$store.dispatch("users/signUpUser", {
      user: item,
      signUp: signUp,
      orgId: this.getOrganization.id,
    });
  }

  public closeEmailDialog() {
    this.emailDialog = false;
    this.newEmail = "";
    this.validateEmailForm();
  }

  private openEmailDialog(item: User) {
    this.emailDialog = true;
    this.rowSelected = item;
  }

  private updateEmail() {
    this.$store.dispatch("users/updateEmail", {
      id: this.rowSelected.id,
      email: this.newEmail,
      orgId: this.getOrganization.id,
    });
  }

  public closePasswordDialog() {
    this.passwordDialog = false;
    this.resetPasswordValidation();
    this.newPassword = "";
    this.confirmPassword = "";
    this.validatePasswordForm();
    this.passwordChangedSuccessfully = false;
    this.passwordResetMessage = "";
  }

  private openPasswordDialog(item: User) {
    this.passwordDialog = true;
    this.rowSelected = item;
  }

  public get passwordConfirmationRules() {
    return [
      () => this.newPassword === this.confirmPassword || "Passwords must match",
      (v) => !!v || "Password Confirmation is Required",
    ];
  }

  private updatePassword() {
    this.$store.dispatch("users/changePassword", {
      id: this.rowSelected.id,
      password: this.newPassword,
      orgId: this.getOrganization.id,
    });
  }

  private resetPasswordValidation() {
    return (this.$refs.passwordForm as Vue & {
      resetValidation: () => boolean;
    }).resetValidation();
  }

  private validatePasswordForm() {
    this.passwordValid = (this.$refs.passwordForm as Vue & {
      validate: () => boolean;
    }).validate();
  }

  private validateEmailForm() {
    this.emailValid = (this.$refs.emailForm as Vue & {
      validate: () => boolean;
    }).validate();
  }

  private resetValidation() {
    return (this.$refs.form as Vue & {
      resetValidation: () => boolean;
    }).resetValidation();
  }

  private validateForm() {
    this.valid = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
  }

  public closeRolesDialog() {
    this.rolesDialog = false;
    this.assignedRoles = [];
  }

  private openRolesDialog(item: User) {
    this.rolesDialog = true;
    this.rowSelected = item;
  }

  private openChangeOrgDialog(item: User) {
    this.changeOrgDialog = true;
    this.rowSelected = item;
  }
  public closeChangeOrgDialog() {
    this.changeOrgDialog = false;
  }

  private assignRoles() {
    this.$store.dispatch("users/assignRoles", {
      id: this.rowSelected.id,
      roleIds: this.assignedRoles,
      orgId: this.getOrganization.id,
    });
  }

  private changeOrg() {
    this.$store
      .dispatch("users/changeUserOrg", {
        organizationId: this.selectedOrg,
        userIds: [this.rowSelected.id],
        originalOrgId: this.getOrganization.id,
      })
      .then(() => {
        this.closeChangeOrgDialog();
      });
  }

  private created() {
    this.pagination = new Pagination(1, 25);
    this.query = "";
    if (this.getOrganization.id) {
      this.$store.dispatch("users/searchAsync", {
        orgId: this.getOrganization.id,
        query: this.query,
      });
    }
  }
}
